module.exports = __webpack_public_path__ + "static/media/contact-slide-2.a702daea.jpg";